/* This file contains custom methods that are added to the base jquery validate plugin using the "additional-methods.js" extension.
* This should be included AFTER both jquery validate and additional methods files and will include useful rules for form validations
*
* 	http://ajax.aspnetcdn.com/ajax/jquery.validate/1.15.0/jquery.validate.min.js
* 	http://ajax.aspnetcdn.com/ajax/jquery.validate/1.15.0/additional-methods.min.js
*
* method that will compare the form value with a given value that it should not equal
* For example, a user should not register using the demo account email address so we can use this to make sure it doesn't (see registration.js for usage)
*/
$.validator.addMethod("notEqual", function(value, element, param) {
	return this.optional(element) || value != param;
});

$.validator.addMethod("greaterThanOrEqual", function(value, element, param) {
	return this.optional(element) || value >= $(param).val();
});

$.validator.addMethod("customPhoneFormat", function(value, element, param) {
	if (param && value.length != 0) {
		if (value.length != 14 ||
			value.substring(0, 1) != "(" ||
			value.substring(4, 5) != ")" ||
			value.substring(9, 10) != "-") {
			return false;
		}
	}
	return true;
});

$.validator.addMethod("reCaptcha", function(value, element, param) {
	if ((typeof element == "undefined") || (value == "")) {
		return false;
	} else {
		return true;
	}
});

$.validator.addMethod("strictEmail", function(value, element, param) {
	emailErrorMessage = "";
	// We'll use our email validation in ValidEmail.js if we have it. Otherwise, we'll use a simple regex.
	if (typeof validateEmailAddress !== "undefined" && typeof validateEmailAddress === "function") {
		emailErrorMessage = validateEmailAddress(value, "N");
	} else {
		var email = new RegExp("^(.)+(@)(.)+[.](.)+$");
		if (!email.test(value)) {
			emailErrorMessage = "Please enter a valid email address";
		}
	}

	if (emailErrorMessage == "") {
		return true;
	} else {
		$(element).data("error", emailErrorMessage);
		return false;
	}
}, function(params, element) {
	return $(element).data("error");
});
